import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectAccessToken, selectIDToken } from "../../slices/staffSlice";
import { Tab } from '@headlessui/react'
import { Topbar, Sidebar, LoansTable, Loader, Alerts } from "../../components";
import { fetchRequests } from "../../Requests/getRequests";
import useConfigOptions from '../../hooks/useConfigOptions';

function Index() {

    const { loanStates } = useConfigOptions();
    const idToken = useSelector(selectIDToken);
    const accessToken = useSelector(selectAccessToken);

    const [loanme, setLoanme] = useState();
    const [capitalme, setCapitalme] = useState();
    const [topup, setTopUp] = useState();
    const [credit, setCredit] = useState();
    const [cashme, setCashMe] = useState();
    const [pension, setPension] = useState();
    const [employer, setEmployer] = useState();
    const [investment, setInvestment] = useState();
    const [loading, setLoading] = useState(false);
    const [alert, setAlert] = useState(false);

    function classNames(...classes) {
        return classes.filter(Boolean).join(' ')
    }

    useEffect(() => {
        let unsubscribed = false;

        const getLoans = async(accessToken, idToken) => {
            setLoading(true);
            let loanmeUrl = `/loan/loanme/list/${loanStates?.disburse}`;
            let capitalmeUrl = `/loan/capitalme/list/${loanStates?.disburse}`;
            let topUpUrl = `/loan/capitalme-topup/list/${loanStates?.disburse}`;
            let creditUrl = `/loan/momo-cedis-credit/list/${loanStates?.disburse}`;
            let cashmeUrl = `/loan/cashme/list/${loanStates?.disburse}`;
            let pensionUrl = `/loan/pension/list/${loanStates?.disburse}`;
            let employerUrl = `/loan/employer-deduction/list/${loanStates?.disburse}`;
            let investmentUrl = `/loan/investment/list/${loanStates?.disburse}`;
            let headers = {
                "Content-Type" : "application/json",
                "Authorization" : `Bearer ${accessToken}`,
                "client-token" : `${idToken}`
            }
            let [loanMeRes, capitalMeRes, topUpRes, creditRes, cashmeRes, pensionRes, employerRes, investmentRes] = await Promise.all([
                fetchRequests(loanmeUrl, "GET", headers, {}, {}), 
                fetchRequests(capitalmeUrl, "GET", headers, {}, {}),
                fetchRequests(topUpUrl, "GET", headers, {}, {}),
                fetchRequests(creditUrl, "GET", headers, {}, {}),
                fetchRequests(cashmeUrl, "GET", headers, {}, {}),
                fetchRequests(pensionUrl, "GET", headers, {}, {}),
                fetchRequests(employerUrl, "GET", headers, {}, {}),
                fetchRequests(investmentUrl, "GET", headers, {}, {}),
            ]);

            if(loanMeRes.name === "TokenExpiredError" || 
                capitalMeRes.name === "TokenExpiredError" || 
                topUpRes.name === "TokenExpiredError" || 
                creditRes.name === "TokenExpiredError" || 
                cashmeRes.name === "TokenExpiredError" || 
                pensionRes.name === "TokenExpiredError" ||
                employerRes.name === "TokenExpiredError" ||
                investmentRes.name === "TokenExpiredError"
            ){
                setAlert({
                    type : "error",
                    state : true,
                    message : "Your session has expired"
                })
            }

            if(loanMeRes.name === "AuthorizationFailed" || 
                capitalMeRes.name === "AuthorizationFailed" || 
                topUpRes.name === "AuthorizationFailed" || 
                creditRes.name === "AuthorizationFailed" || 
                cashmeRes.name === "AuthorizationFailed" || 
                pensionRes.name === "AuthorizationFailed" ||
                employerRes.name === "AuthorizationFailed" ||
                investmentRes.name === "AuthorizationFailed"
            ){
                setAlert({
                    type : "error",
                    state : true,
                    message : "You do not have access"
                })
            }
            
            if(!unsubscribed){
                if(loanMeRes.status === true && capitalMeRes.status === true && topUpRes.status === true && creditRes?.status && cashmeRes.status === true && pensionRes.status === true && employerRes.status === true && investmentRes.status === true){
                    setLoanme(loanMeRes?.data);
                    setCapitalme(capitalMeRes?.data);
                    setTopUp(topUpRes?.data);
                    setCredit(creditRes?.data);
                    setCashMe(cashmeRes?.data);
                    setPension(pensionRes?.data);
                    setEmployer(employerRes?.data);
                    setInvestment(investmentRes?.data);
                }
            }

            setLoading(false);
        }

        getLoans(accessToken, idToken);

        return () => {
            unsubscribed = true
        }
    },[accessToken, idToken, loanStates?.disburse])

    return (
        <div className='main-container'>
            <Alerts 
                type={alert.type}
                state={alert.state}
                message={alert.message}
                setAlert={setAlert}
            />

            <Topbar />
            <Sidebar setAlert={setAlert} />

            <main className='main-content'>

                <section className='section-container'>
                    <h3 className='text-3xl font-medium leading-6 text-display mb-6 inline-flex items-center'>
                        Approved Applications {loading && <Loader color={"text-gray-700"} size={"w-5 h-5 ml-2"} />}
                    </h3>
                    

                    <Tab.Group>
                        <Tab.List className="flex space-x-1 rounded-xl p-1">
                            <Tab className={({ selected }) => classNames('w-full rounded-lg py-2.5 text-sm font-medium leading-5 text-white', selected ? 'bg-dark-blue shadow' : 'text-dark-blue hover:bg-light-blue hover:text-white')}>
                                LoanMe
                            </Tab>
                            <Tab className={({ selected }) => classNames('w-full rounded-lg py-2.5 text-sm font-medium leading-5 text-white', selected ? 'bg-dark-blue shadow' : 'text-dark-blue hover:bg-light-blue hover:text-white')}>
                                CapitalMe
                            </Tab>
                            <Tab className={({ selected }) => classNames('w-full rounded-lg py-2.5 text-sm font-medium leading-5 text-white', selected ? 'bg-dark-blue shadow' : 'text-dark-blue hover:bg-light-blue hover:text-white')}>
                                C. Top-up
                            </Tab>
                            <Tab className={({ selected }) => classNames('w-full rounded-lg py-2.5 text-sm font-medium leading-5 text-white', selected ? 'bg-dark-blue shadow' : 'text-dark-blue hover:bg-light-blue hover:text-white')}>
                                CedisCredit
                            </Tab>
                            <Tab className={({ selected }) => classNames('w-full rounded-lg py-2.5 text-sm font-medium leading-5 text-white', selected ? 'bg-dark-blue shadow' : 'text-dark-blue hover:bg-light-blue hover:text-white')}>
                                CashMe
                            </Tab>
                            <Tab className={({ selected }) => classNames('w-full rounded-lg py-2.5 text-sm font-medium leading-5 text-white', selected ? 'bg-dark-blue shadow' : 'text-dark-blue hover:bg-light-blue hover:text-white')}>
                                Pension
                            </Tab>
                            <Tab className={({ selected }) => classNames('w-full rounded-lg py-2.5 text-sm font-medium leading-5 text-white', selected ? 'bg-dark-blue shadow' : 'text-dark-blue hover:bg-light-blue hover:text-white')}>
                                Employer
                            </Tab>
                            <Tab className={({ selected }) => classNames('w-full rounded-lg py-2.5 text-sm font-medium leading-5 text-white', selected ? 'bg-dark-blue shadow' : 'text-dark-blue hover:bg-light-blue hover:text-white')}>
                                Investment
                            </Tab>
                        </Tab.List>

                        <Tab.Panels className="mt-2">
                            {/* loanme applications */}
                            {loanme && 
                                <Tab.Panel className={classNames('rounded-xl bg-white p-3')}>
                                    <LoansTable loan={loanme} />
                                </Tab.Panel>
                            }

                            {/* capitalme applications */}
                            {capitalme &&
                                <Tab.Panel className={classNames('rounded-xl bg-white p-3')}>
                                    <LoansTable loan={capitalme} />
                                </Tab.Panel>
                            }

                            {/* capitalme-topup applications */}
                            {topup &&
                                <Tab.Panel className={classNames('rounded-xl bg-white p-3')}>
                                    <LoansTable loan={topup} />
                                </Tab.Panel>
                            }

                            {/* cediscredit applications */}
                            {credit &&
                                <Tab.Panel className={classNames('rounded-xl bg-white p-3')}>
                                    <LoansTable loan={credit} />
                                </Tab.Panel>
                            }

                            {/* cashme applications */}
                            {cashme &&
                                <Tab.Panel className={classNames('rounded-xl bg-white p-3')}>
                                    <LoansTable loan={cashme} />
                                </Tab.Panel>
                            }

                            {/* pension applications */}
                            {pension &&
                                <Tab.Panel className={classNames('rounded-xl bg-white p-3')}>
                                    <LoansTable loan={pension} />
                                </Tab.Panel>
                            }                        

                            {/* employer applications */}
                            {employer &&
                                <Tab.Panel className={classNames('rounded-xl bg-white p-3')}>
                                    <LoansTable loan={employer} />
                                </Tab.Panel>
                            }                        

                            {/* investment applications */}
                            {investment &&
                                <Tab.Panel className={classNames('rounded-xl bg-white p-3')}>
                                    <LoansTable loan={investment} />
                                </Tab.Panel>
                            }                        
                        </Tab.Panels>
                    </Tab.Group>

                </section>

            </main>

        </div>
    )
}

export default Index